import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getBuilding } from '../../services/buildingService';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import BuildingGatesTab from './tab-pages/BuildingGatesTab';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 8px;
`;

export default function BuildingDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [building, setBuilding] = useState(null);
  const [activeTab, setActiveTab] = useState('gates');

  useEffect(() => {
    getBuilding(id)
      .then((res) => setBuilding(res.data?.data))
      .catch(() => {});
  }, [id]);

  const tabs = [
    { key: 'gates', label: t('gate.title') },
  ];

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('building.title'), path: '/buildings' },
          { label: building?.name || '...' },
        ]} />

        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      </StickyHeader>

      <TabContent>
        {activeTab === 'gates' && <BuildingGatesTab buildingId={id} />}
      </TabContent>
    </PageContainer>
  );
}
